import sdl from '@jds/react-generated-sdl/JDSImage';
import type { JDSImageProps } from './interface';

import { componentsMap } from '../../../generators/componentMap';
import {
  createComponent,
  getCustomJSON,
  useTokenValues
} from '@jds/react-engine';

import { withLogic, ImageProps } from '../logic';

const Component = (props: ImageProps) => {
  const { platform } = useTokenValues();

  const json = sdl;
  const {
    aspectRatio = 'square',
    roundedCorner = true,
    contentScale = 'cover',
    imageFocus = 'center',
    custom = '',
    ...rest
  } = props as any;
  return createComponent(
    json,
    { aspectRatio, roundedCorner, contentScale, imageFocus, ...rest },
    'JDSImage',
    componentsMap,
    getCustomJSON(custom || '') || {}
  );
};

const Image = withLogic(Component) as React.FC<ImageProps> & {
  slotName?: string;
};

Image.displayName = 'Image';
Image.slotName = 'jds_image';

export { Image, type JDSImageProps };
